// Unpublished Work © 2020-2023 Deere & Company

import t from 'tcomb';

export const Routing = t.struct({
    view: t.String,
    searchBreadcrumbLabel: t.String,
    persistBreadcrumbOnAllPages: t.Boolean
}, {
    defaultProps: {
        view: 'CUSTOMER_SEARCH',
        searchBreadcrumbLabel: '',
        persistBreadcrumbOnAllPages: false
    },
    name: 'Routing',
    strict: true
});
